import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DadosRoutingModule } from './dados-routing.module';
import { DadosHomeComponent } from './dados-home/dados-home.component';
import { DadosReceitasComponent } from './dados-receitas/dados-receitas.component';
import { DadosReceitasFormComponent } from './dados-receitas-form/dados-receitas-form.component';
import { DadosProfissoesComponent } from './dados-profissoes/dados-profissoes.component';
import { DadosDespesasComponent } from './dados-despesas/dados-despesas.component';
import { DadosPastasComponent } from './dados-pastas/dados-pastas.component';
import { DadosServicosComponent } from './dados-servicos/dados-servicos.component';
import { DadosRepasseComponent } from './dados-repasse/dados-repasse.component';
import { DialogModule } from 'primeng/dialog';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { DadosProfissoesFormComponent } from './dados-profissoes-form/dados-profissoes-form.component';
import { DadosDespesasFormComponent } from './dados-despesas-form/dados-despesas-form.component';
import { DadosPastasFormComponent } from './dados-pastas-form/dados-pastas-form.component';
import { DadosServicosFormComponent } from './dados-servicos-form/dados-servicos-form.component';
import { DynamicDialogModule } from 'primeng/dynamicdialog';

@NgModule({
  declarations: [
    DadosHomeComponent,
    DadosReceitasComponent,
    DadosReceitasFormComponent,
    DadosProfissoesComponent,
    DadosDespesasComponent,
    DadosPastasComponent,
    DadosServicosComponent,
    DadosRepasseComponent,
    DadosProfissoesFormComponent,
    DadosDespesasFormComponent,
    DadosPastasFormComponent,
    DadosServicosFormComponent,
  ],
  imports: [
    CommonModule,
    DadosRoutingModule,
    DialogModule,
    SharedModule,
    RouterModule,
    DynamicDialogModule
  ],
})
export class DadosModule {}
